import * as dataSelectors from '@/data/data-selectors';
import * as listSelectors from '@/list/list-selectors';
import { MapboxInstanceMgr } from '@/map/map-instance';
import * as userSelectors from '@/user/user-selectors';
import { useMemo } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { RefocusButton } from './control-buttons';
import { refocusBtnCallback } from './ctrl-button-cbs';
import { HoaInfoBox } from './hoa-info-box';
import { ListingSummary } from './listing-summary';
import { MapLayerCtrlGroup } from './map-layer-ctrl-group';

export function CustomMapControls(props) {
  const { customControlNodes, city } = props;
  const cityMode = useSelector(userSelectors.derivedCityMode);
  const currentCity = useSelector((state) => state.user.currentCity);
  const currentCityPlaceNS = useSelector(dataSelectors.cityPlaceNS);
  const customerConfigIncludesCities = useSelector(
    dataSelectors.customerConfigIncludesCities
  );
  const cityDisplayName = useSelector(
    (state) => state.data.stats.rentalscape.name
  );

  const listingTypes = useSelector((state) => state.data.stats.listings);

  const isTot = useMemo(
    () => !!listingTypes.find((l) => l.configType === 'tot'),
    [listingTypes]
  );

  const listings = useSelector((state) => state.data.propertyList);
  const { mapInstance } = MapboxInstanceMgr.getInstance();
  const platformToDisplayConfig = useSelector(dataSelectors.platformIcons);
  const displayUnlicensedPropertiesSeparately = useSelector(
    listSelectors.isLicensingEnabled
  );

  return (
    <>
      {ReactDOM.createPortal(
        <ListingSummary
          cityMode={cityMode}
          currentCity={currentCity}
          currentCityPlaceNS={currentCityPlaceNS}
          customerConfigIncludesCities={customerConfigIncludesCities}
          cityDisplayName={cityDisplayName}
          listings={listings}
          platformToDisplayConfig={platformToDisplayConfig}
          displayUnlicensedPropertiesSeparately={
            displayUnlicensedPropertiesSeparately
          }
          isTot={isTot}
        />,
        customControlNodes.listingSummaryBtn
      )}
      ,
      {ReactDOM.createPortal(
        <MapLayerCtrlGroup map={mapInstance} city={city} />,
        customControlNodes.mapLayerCtrlGroup
      )}
      {ReactDOM.createPortal(
        <RefocusButton onClick={() => refocusBtnCallback(city, mapInstance)} />,
        customControlNodes.refocusBtn
      )}
      {ReactDOM.createPortal(<HoaInfoBox />, customControlNodes.hoaInfoBox)}
    </>
  );
}
